import { AlpineComponent } from "@nxtlvlsoftware/alpine-typescript";


export class DrawerComponent extends AlpineComponent {
    public open: Boolean = false;

    constructor() {
        super();
    }

    protected drawerClose = this.binding({
        ["x-on:click"]() {
            this.open = false
        }
    });

    protected drawerOverlay = this.binding({
        [":class"]: "{ 'requires-no-scroll': open }",
        ["x-transition:enter"]: "ease-out duration-500",
        ["x-transition:enter-start"]: "opacity-0",
        ["x-transition:enter-end"]: "opacity-100",
        ["x-transition:leave"]: "ease-in duration-500",
        ["x-transition:leave-start"]: "opacity-100",
        ["x-transition:leave-end"]: "opacity-0",
        ["x-show"]() {
            return this.open
        },
    });

    protected drawerContent = this.binding({
        ["x-transition:enter"]: "transform transition ease-out duration-500 sm:duration-700",
        ["x-transition:enter-start"]: "translate-x-full",
        ["x-transition:enter-end"]: "translate-x-0",
        ["x-transition:leave"]: "transform transition ease-in duration-500 sm:duration-700",
        ["x-transition:leave-start"]: "translate-x-0",
        ["x-transition:leave-end"]: "translate-x-full",
        ["x-on:click.outside"]: "open = false",
        ["x-show"]() {
            return this.open
        },
    });
}